import { createFileRoute } from "@tanstack/react-router";
import FAQPage from "@/pages/FAQ";
import { pageHead } from "@/lib/pageHead";
import { faqJsonLd } from "@/lib/faqContent";

export const Route = createFileRoute("/en/faq")({
  head: () => ({
    ...pageHead("faq", "en"),
    scripts: [{ type: "application/ld+json", children: JSON.stringify(faqJsonLd("en")) }],
  }),
  component: FAQPage,
});
